import axios from "axios";
import { auth } from "../auth/firebase.js";

// Backend URL - same as your existing services
export const functionsURL = "https://app-63xryff43a-uc.a.run.app";
// export const functionsURL = "http://127.0.0.1:5001/admin-ciet/us-central1/app"

/**
 * Format date to DD-MMM-YYYY format (e.g., "18-Feb-2026")
 */
const formatDate = (date) => {
  if (!date) return '';
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const month = months[d.getMonth()];
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};
// export async function generateBatchPendingInvoice(studentData, courseData, lineItems) {
//   // lineItems: [{ label, amount, dueDate }, ...]
//   // Build one invoice with all line items — adapt to your Axcelerate/invoice API shape
//   try {
//     const invoiceNumber = `INV-BATCH-${Date.now()}`;
//     // ... your API call here, passing lineItems as an array
//     return { success: true, invoiceNumber };
//   } catch (err) {
//     return { success: false, error: err.message };
//   }
// }

/**
 * Format currency amount (e.g., "1,650.00")
 */
const formatCurrency = (amount) => {
  const num = parseFloat(amount || 0);
  return num.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
};

/**
 * Generate invoice number based on student ID and installment index
 */
const generateInvoiceNumber = (studentId, currentDate) => {
  const cleanStudentId = studentId?.replace(/^test\s+/i, '') || 'UNKNOWN';
  
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const dateStr = `${year}${month}${day}`;
  
  return `${cleanStudentId}-${dateStr}`;
};


/**
 * Build the replaceContent object for the invoice template
 */
const buildInvoiceData = (studentData, courseData, installment, installmentIndex) => {
  let currentDate = new Date();
  const dueDate = new Date(installment.dueDate);

  if (dueDate < currentDate) {
    currentDate = dueDate;
  }

  const invoiceNumber = installment.invoiceNumber || generateInvoiceNumber(
    studentData.studentId,
    dueDate
  );

  const installmentLabel = installmentIndex === -1
    ? 'Initial Deposit'
    : `Instalment #${installmentIndex + 1}`;

  const amount = parseFloat(installment.depositAmount || 0);
  const fullAddress = studentData.address;

  // Same table structure as batch — just one instalment row
  const courseInstallmentHTML =
    `<table border="1" cellpadding="1" cellspacing="0" style="width:100%; border-collapse: collapse;">
      <tbody>

        <tr style="background-color: #f2f2f2;">
          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 50%;">
            <span style="font-size:16px;"><strong>DESCRIPTION</strong></span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 25%;">
            <span style="font-size:16px;"><strong>DUE DATE</strong></span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 25%; text-align: right;">
            <span style="font-size:16px;"><strong>AMOUNT ($)</strong></span>
          </td>
        </tr>

        <tr>
          <td colspan="3" style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">
              <strong>${courseData.courseName || courseData.name || ""}</strong>
            </span>
          </td>
        </tr>

        <tr>
          <td style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">1. ${installmentLabel}</span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">${formatDate(installment.dueDate)}</span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;">$${formatCurrency(amount)}</span>
          </td>
        </tr>

        <tr style="background-color: #f2f2f2;">
          <td colspan="2" style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;"><strong>Total</strong></span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;"><strong>$${formatCurrency(amount)}</strong></span>
          </td>
        </tr>

      </tbody>
    </table>`;

  return {
    InvoiceNumber: invoiceNumber,
    CurrentDate: formatDate(currentDate),
    DueDate: formatDate(installment.dueDate),
    EarlierDueDate: formatDate(installment.dueDate),

    BillToName: `${studentData.firstName || ''} ${studentData.lastName || ''}`.trim(),
    BillToAddress: fullAddress,

    CourseName: courseData.courseName || courseData.name || '',
    CourseInstallment: courseInstallmentHTML,
    CourseTotalAmount: formatCurrency(courseData.feesPlan?.totalFees || 0),

    traineeFullName: `${studentData.firstName || ''} ${studentData.lastName || ''}`.trim(),
    amount: formatCurrency(amount),
    Duedate: formatDate(installment.dueDate),
    givendate: formatDate(currentDate),
  };
};
const generateReceiptNumber = (studentId, currentDate) => {
  const cleanStudentId = studentId?.replace(/^test\s+/i, "") || "UNKNOWN";

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");

  return `${cleanStudentId}-${year}${month}${day}`;
};

const buildReceiptData = (studentData, courseData, installment, installmentIndex) => {
  const currentDate = new Date();

  const receiptNumber =
    generateReceiptNumber(studentData.studentId, currentDate);

  const installmentLabel =
    installmentIndex === -1
      ? "Initial Deposit"
      : `Instalment #${installmentIndex + 1}`;

  const amountPaid = parseFloat(
    installment.amountPaid || installment.depositAmount || 0
  );

  const paidDate =
    installment.receiptReferenceDate ||
    installment.paymentDate ||
    currentDate;

  const courseName = courseData.courseName || courseData.name || "";

  const receiptInstallmentHTML = `
    <table border="1" cellpadding="1" cellspacing="0" style="width:100%; border-collapse: collapse;">
      <tbody>
        <tr style="background-color: #f2f2f2;">
          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 50%;">
            <span style="font-size:16px;"><strong>DESCRIPTION</strong></span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 25%;">
            <span style="font-size:16px;"><strong>PAYMENT DATE</strong></span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 25%; text-align: right;">
            <span style="font-size:16px;"><strong>AMOUNT PAID ($)</strong></span>
          </td>
        </tr>

        <tr>
          <td colspan="3" style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">
              <strong>${courseName}</strong>
            </span>
          </td>
        </tr>

        <tr>
          <td style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">1. ${installmentLabel}</span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">${formatDate(paidDate)}</span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;">$${formatCurrency(amountPaid)}</span>
          </td>
        </tr>

        <tr style="background-color: #f2f2f2;">
          <td colspan="2" style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;"><strong>Total Paid</strong></span>
          </td>
          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;"><strong>$${formatCurrency(amountPaid)}</strong></span>
          </td>
        </tr>
      </tbody>
    </table>
  `;

  return {
    ReceiptNumber: receiptNumber,
    CurrentDate: formatDate(currentDate),
    ReceiptDate: formatDate(paidDate),
    PaymentDate: formatDate(paidDate),

    InvoiceNumber: installment.invoiceNumber || "",
    ReferenceNumber: installment.receiptReferenceNo || receiptNumber,

    BillToName: `${studentData.firstName || ""} ${studentData.lastName || ""}`.trim(),
    BillToAddress: studentData.address || "",

    CourseName: courseName,
    CourseInstallment: receiptInstallmentHTML,
    ReceiptInstallment: receiptInstallmentHTML,

    traineeFullName: `${studentData.firstName || ""} ${studentData.lastName || ""}`.trim(),

    amount: formatCurrency(amountPaid),
    amountPaid: formatCurrency(amountPaid),
    paymentAmount: formatCurrency(amountPaid),

    feesPaidTo: installment.feesPaidTo || "",
    notes: installment.notes || "",
  };
};

export const generateReceipt = async (
  studentData,
  courseData,
  installment,
  installmentIndex
) => {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not signed in");

    const token = await user.getIdToken();

    const replaceContent = buildReceiptData(
      studentData,
      courseData,
      installment,
      installmentIndex
    );

    const response = await axios.post(
      `${functionsURL}/api/receipt/send`,
      {
        contactID: studentData.contactID,
        replaceContent,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      receiptNumber: replaceContent.ReceiptNumber,
      sentDate: new Date().toISOString(),
      response: response.data,
      replaceContent,
    };
  } catch (error) {
    console.error("Receipt generation error:", error);

    return {
      success: false,
      error:
        error.response?.data?.error ||
        error.message ||
        "Failed to generate receipt",
    };
  }
};

export const generateInstallmentReceipt = async (
  studentData,
  courseData,
  installmentIndex
) => {
  const installment = courseData.feesPlan.installments[installmentIndex];

  if (!installment) {
    throw new Error(`Installment ${installmentIndex} not found`);
  }

  return generateReceipt(studentData, courseData, installment, installmentIndex);
};
const buildBatchReceiptData = (studentData, courseData, lineItems) => {
  const currentDate = new Date();
  const receiptNumber = generateReceiptNumber(studentData.studentId, currentDate);

  const totalAmount = lineItems.reduce(
    (sum, item) => sum + parseFloat(item.amount || 0),
    0
  );

  const firstPaidDate = lineItems
    .map((item) => item.paidDate || item.paymentDate || item.receiptReferenceDate)
    .filter(Boolean)
    .map((date) => new Date(date))
    .sort((a, b) => a - b)[0] || currentDate;

  const courseName = courseData.courseName || courseData.name || "";

  const tableRows = lineItems
    .map((item, i) => {
      const paidDate =
        item.paidDate ||
        item.paymentDate ||
        item.receiptReferenceDate ||
        currentDate;

      return `
        <tr>
          <td style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">
              ${i + 1}. ${item.label || `Instalment #${i + 1}`}
            </span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">
              ${formatDate(paidDate)}
            </span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;">
              $${formatCurrency(item.amount)}
            </span>
          </td>
        </tr>
      `;
    })
    .join("");

  const receiptInstallmentHTML = `
    <table border="1" cellpadding="1" cellspacing="0" style="width:100%; border-collapse: collapse;">
      <tbody>
        <tr style="background-color: #f2f2f2;">
          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 40%;">
            <span style="font-size:16px;"><strong>DESCRIPTION</strong></span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 20%;">
            <span style="font-size:16px;"><strong>PAYMENT DATE</strong></span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 20%; text-align: right;">
            <span style="font-size:16px;"><strong>AMOUNT PAID ($)</strong></span>
          </td>
        </tr>

        <tr>
          <td colspan="3" style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">
              <strong>${courseName}</strong>
            </span>
          </td>
        </tr>

        ${tableRows}

        <tr style="background-color: #f2f2f2;">
          <td colspan="2" style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;"><strong>Total Paid</strong></span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;">
              <strong>$${formatCurrency(totalAmount)}</strong>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  `;

  return {
    ReceiptNumber: receiptNumber,
    CurrentDate: formatDate(currentDate),
    ReceiptDate: formatDate(firstPaidDate),
    PaymentDate: formatDate(firstPaidDate),

    BillToName: `${studentData.firstName || ""} ${studentData.lastName || ""}`.trim(),
    BillToAddress: studentData.address || "",

    CourseName: courseName,

    CourseInstallment: receiptInstallmentHTML,
    ReceiptInstallment: receiptInstallmentHTML,

    traineeFullName: `${studentData.firstName || ""} ${studentData.lastName || ""}`.trim(),

    amount: formatCurrency(totalAmount),
    amountPaid: formatCurrency(totalAmount),
    paymentAmount: formatCurrency(totalAmount),

    ReferenceNumber: receiptNumber,
    InvoiceNumber: lineItems.map((item) => item.invoiceNumber).filter(Boolean).join(", "),

    feesPaidTo: "",
    notes: "",
  };
};

export async function generateBatchCombinedReceipt(studentData, courseData, lineItems) {
  try {
    const user = auth.currentUser;

    if (!user) {
      throw new Error("User not signed in");
    }

    const token = await user.getIdToken();

    const replaceContent = buildBatchReceiptData(
      studentData,
      courseData,
      lineItems
    );

    const response = await axios.post(
      `${functionsURL}/api/receipt/send`,
      {
        contactID: studentData.contactID,
        replaceContent,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      receiptNumber: replaceContent.ReceiptNumber,
      sentDate: new Date().toISOString(),
      response: response.data,
      replaceContent,
    };
  } catch (error) {
    console.error("generateBatchCombinedReceipt error:", error);

    return {
      success: false,
      error:
        error.response?.data?.error ||
        error.message ||
        "Failed to generate batch receipt",
    };
  }
}

/**
 * Generate and send invoice via backend API (avoids CORS)
 */
export const generateInvoice = async (studentData, courseData, installment, installmentIndex) => {
  try {
    // Check if contactID exists
    // if (!studentData.contactID) {
    //   throw new Error('Student contactID is missing. Please sync student with Axcelerate first.');
    // }

    // Get Firebase auth token
    const user = auth.currentUser;
    if (!user) throw new Error("User not signed in");
    const token = await user.getIdToken();

    // Build invoice data
    const replaceContent = buildInvoiceData(studentData, courseData, installment, installmentIndex);
    console.log("replaceContent:", replaceContent);
    console.log("replaceContent size:", JSON.stringify(replaceContent).length);
    console.log("CourseInstallment size:", replaceContent.CourseInstallment?.length);
    
    // Call YOUR backend (which then calls Axcelerate)
    const response = await axios.post(
      `${functionsURL}/api/invoice/send`,
      {
        contactID: studentData.contactID,
        replaceContent: replaceContent
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      invoiceNumber: replaceContent.InvoiceNumber,
      sentDate: new Date().toISOString(),
      response: response.data,
      replaceContent: replaceContent
    };

  } catch (error) {
    console.error('Invoice generation error:', error);
    return {
      success: false,
      error: error.response?.data?.error || error.message || 'Failed to generate invoice'
    };
  }
};

/**
 * Generate invoice for initial deposit
 */
export const generateInitialDepositInvoice = async (studentData, courseData) => {
  return generateInvoice(
    studentData,
    courseData,
    courseData.feesPlan.initialDeposit,
    -1
  );
};

/**
 * Generate invoice for a specific installment
 */
export const generateInstallmentInvoice = async (studentData, courseData, installmentIndex) => {
  const installment = courseData.feesPlan.installments[installmentIndex];
  if (!installment) {
    throw new Error(`Installment ${installmentIndex} not found`);
  }

  return generateInvoice(
    studentData,
    courseData,
    installment,
    installmentIndex
  );
};

export default {
  generateInvoice,
  generateInitialDepositInvoice,
  generateInstallmentInvoice
};
/**
 * Build replaceContent for batch invoice using EXACT same placeholder names
 * as the single invoice template — line items appended with spacing
 */
const buildBatchInvoiceData = (studentData, courseData, lineItems) => {
  const currentDate = new Date();
  const invoiceNumber = generateInvoiceNumber(studentData.studentId, currentDate);

  const safeLineItems = Array.isArray(lineItems) ? lineItems : [];

  const pendingSubtotal = safeLineItems
    .filter((item) => item.lineType !== "late_fine" && !item.isFineLine)
    .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

  const fineSubtotal = safeLineItems
    .filter((item) => item.lineType === "late_fine" || item.isFineLine)
    .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

  const totalAmount = pendingSubtotal + fineSubtotal;
  const addDays = (date, days) => {
    const d = new Date(date);
    d.setDate(d.getDate() + days);
    return d;
  };

  const hasFineLine = safeLineItems.some(
    (item) => item.lineType === "late_fine" || item.isFineLine
  );

  const earliestDue =
    safeLineItems
      .filter((item) => item.lineType !== "late_fine" && !item.isFineLine)
      .map((i) => i.dueDate)
      .filter(Boolean)
      .map((date) => new Date(date))
      .sort((a, b) => a - b)[0] || currentDate;

  const fineDueDate = addDays(currentDate, 7);

  const invoiceDueDate = hasFineLine ? fineDueDate : earliestDue;

  const fullAddress = studentData.address;
  const courseName = courseData.courseName || courseData.name || "";

  const tableRows = safeLineItems
    .map((item, i) => {
      const isFineLine = item.lineType === "late_fine" || item.isFineLine;

      const rowStyle = isFineLine
        ? "background-color: #ffffff; font-weight:700;"
        : "";

      const amountStyle = isFineLine
        ? " font-weight:700;"
        : "";

      const descriptionText =
        item.description ||
        (isFineLine && item.lateWeeks
          ? `${item.lateWeeks} week${Number(item.lateWeeks) > 1 ? "s" : ""} × $${item.fineAmountPerWeek || 100} per week`
          : "");

      const descriptionHTML =
        isFineLine &&
        Array.isArray(item.fineBreakdown) &&
        item.fineBreakdown.length > 0
          ? item.fineBreakdown
              .map(
                (line, index) =>
                  `${line}${index < item.fineBreakdown.length - 1 ? ";" : ""}`
              )
              .join("<br />")
          : String(descriptionText || "").replace(/\n/g, "<br />");

      return `
        <tr style="${rowStyle}">
          <td style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">
              ${i + 1}. ${item.label || `Instalment #${i + 1}`}
              ${item.isUpcoming ? " <em>(upcoming)</em>" : ""}
            </span>

            ${
              descriptionHTML
                ? `<br />
                   <span style="font-size:13px; color:#6b7280; line-height:1.5;">
                     ${descriptionHTML}
                   </span>`
                : ""
            }
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">${formatDate(item.dueDate)}</span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px; ${amountStyle}">
              $${formatCurrency(item.amount)}
            </span>
          </td>
        </tr>
      `;
    })
    .join("");

  const subtotalRows =
    fineSubtotal > 0
      ? `
        <tr>
          <td colspan="2" style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;"><strong>Pending Instalment Total</strong></span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;"><strong>$${formatCurrency(pendingSubtotal)}</strong></span>
          </td>
        </tr>

        <tr style="background-color: #ffffff;">
          <td colspan="2" style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;"><strong>Late Fine Total</strong></span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;"><strong>$${formatCurrency(fineSubtotal)}</strong></span>
          </td>
        </tr>
      `
      : "";

  const courseInstallmentHTML = `
    <table border="1" cellpadding="1" cellspacing="0" style="width:100%; border-collapse: collapse;">
      <tbody>
        <tr style="background-color: #f2f2f2;">
          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 50%;">
            <span style="font-size:16px;"><strong>DESCRIPTION</strong></span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 25%;">
            <span style="font-size:16px;"><strong>DUE DATE</strong></span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; width: 25%; text-align: right;">
            <span style="font-size:16px;"><strong>AMOUNT ($)</strong></span>
          </td>
        </tr>

        <tr>
          <td colspan="3" style="padding: 6px 10px; border: 1px solid #ccc;">
            <span style="font-size:16px;">
              <strong>${courseName}</strong>
            </span>
          </td>
        </tr>

        ${tableRows}

        

        <tr style="background-color: #f2f2f2;">
          <td colspan="2" style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;"><strong>Total Amount</strong></span>
          </td>

          <td style="padding: 6px 10px; border: 1px solid #ccc; text-align: right;">
            <span style="font-size:16px;"><strong>$${formatCurrency(totalAmount)}</strong></span>
          </td>
        </tr>
      </tbody>
    </table>
  `;

  return {
    InvoiceNumber: invoiceNumber,
    CurrentDate: formatDate(currentDate),
    DueDate: formatDate(invoiceDueDate),
    EarlierDueDate: formatDate(earliestDue),

    BillToName: `${studentData.firstName || ""} ${studentData.lastName || ""}`.trim(),
    BillToAddress: fullAddress,

    CourseName: courseName,

    CourseInstallment: courseInstallmentHTML,

    traineeFullName: `${studentData.firstName || ""} ${studentData.lastName || ""}`.trim(),

    amount: formatCurrency(totalAmount),
    EarlierDueDate: formatDate(earliestDue),
    DueDate: formatDate(invoiceDueDate),
    givendate: formatDate(currentDate),
  };
};

/**
 * Generate and send a combined invoice for multiple pending/overdue instalments
 */
export async function generateBatchPendingInvoice(studentData, courseData, lineItems) {
  try {
    const user = auth.currentUser;
    if (!user) throw new Error("User not signed in");
    const token = await user.getIdToken();

    const replaceContent = buildBatchInvoiceData(studentData, courseData, lineItems);

    const response = await axios.post(
      `${functionsURL}/api/invoice/send`,
      {
        contactID: studentData.contactID,
        replaceContent: replaceContent,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    return {
      success: true,
      invoiceNumber: replaceContent.InvoiceNumber,
      sentDate: new Date().toISOString(),
      response: response.data,
      replaceContent: replaceContent,
    };
  } catch (error) {
    console.error("generateBatchPendingInvoice error:", error);
    return {
      success: false,
      error: error.response?.data?.error || error.message || "Failed to generate batch invoice",
    };
  }
}